import React from 'react';
import { loadFromLocalStorage } from '../../../Common/Validation/LocalStorage';
import { TableColumn } from 'react-data-table-component';
import CustomMaterialMenu from '../../../Component/DataGrid/Plugins/CustomMaterialMenu/CustomMaterialMenu';
import DataGrid from '../../../Component/DataGrid/DataGrid';
import BankPartnerServices from '../../../Services/BankPartnerServices';
import { ShowAlert } from '../../../Component/ShowAlert';
import { IBankPartner, BankPartnersState, BankPartnersProps } from './InterfaceBankPartner'
import { SyncContext, SyncContextType } from '../../../Contexts/BatchSyncContext';
import UserAndPermissionService from '../../../Services/UserAndPermissionService';
import BankPartnerForm from './AddOrUpdateBankPartners';

// Main class for BankPartners component
class BankPartners extends React.Component<BankPartnersProps, BankPartnersState> {
    static contextType = SyncContext;
    context!: SyncContextType;

    // Table columns for DataGrid
    private tableColumns: TableColumn<IBankPartner>[] = [
        {
            name: 'Bank Name',
            selector: row => row.bankName,
            sortable: true,
            id: "bank_name",
            grow: 2
        },
        {
            name: 'Plaid Bank Name',
            selector: row => row.plaidBankName,
            sortable: true,
            id: "plaid_bank_name",
            grow: 2
        },
        {
            name: 'Actions',
            cell: row => {
                const { bankPartner } = this.state;
                const menuItems = [
                    ...(bankPartner.isEditVisible
                        ? [{ key: "edit", label: "Edit Bank Partner" }]
                        : []),
                    ...(bankPartner.isDeleteVisible
                        ? [{ key: "delete", label: "Delete" }]
                        : [])
                ];

                if (menuItems.length === 0) return null;

                return (
                    <CustomMaterialMenu
                        fontSize="small"
                        multiPopoverItems={menuItems}
                        onPopoverClick={(key_: string) => {
                            if (key_ === "edit") {
                                this.setState({
                                    isOpenBankPartnerForm: true,
                                    isEditMode: true,
                                    selectedBankPartner: row,
                                });
                            } else if (key_ === "delete") {
                                this.deleteBankPartner(row)
                            }
                        }}
                        disabled={false}
                    />
                );
            },
            allowOverflow: true,
            button: true,
            width: '120px'
        }
    ];

    constructor(props_: BankPartnersProps) {
        super(props_);
        this.state = {
            accessToken: "",
            bankPartnerList: [],
            currentRowsPerPage: 10,
            currentPage: 1,
            totalRows: 0,
            searchText: "",
            filterValue: "",
            selectedBankPartner: {} as IBankPartner,
            bankPartner: {
                isVisible: true,
                isDownloadVisible: true,
                isAddPartner: true,
                isEditVisible: true,
                isDeleteVisible: true,
            },
            paginationReset: false,
            isOpenBankPartnerForm: false,
            isEditMode: false
        }
    }

    async componentDidMount() {
        try {
            const accessToken_ = await loadFromLocalStorage('accessToken');
            const profile_ = await loadFromLocalStorage('profile');

            if (!accessToken_ || !profile_) {
                localStorage.clear();
                window.location.href = '/';
                return;
            }

            const accessToken = accessToken_.toString();
            const userProfile = typeof profile_ === 'string' ? JSON.parse(profile_) : profile_;

            this.setState({ accessToken }, async () => {
                try {
                    if (userProfile?.roleId) {
                        const permissionResponseRaw = await UserAndPermissionService.getPermissions(accessToken, userProfile?.roleId);
                        const permissionResponse = await permissionResponseRaw.json();

                        if (!permissionResponse?.permissions?.bankPartner?.isVisible) {
                            console.warn("Permission denied, logging out...");
                            localStorage.clear();
                            window.location.href = '/';
                            return;
                        }

                        const permissions = permissionResponse.permissions

                        this.context.dispatch({
                            type: "SET_PERMISSION", payload: {
                                permissions
                            },
                        });

                        const bankPartner = permissionResponse.permissions.bankPartner

                        this.setState({ bankPartner }, () => {
                            this.getAllBankPartners()
                        });

                    } else {
                        this.getAllBankPartners()
                    }
                } catch (error) {
                    console.error("Error fetching permissions:", error);
                }
            });
        } catch (error) {
            console.error("Error in componentDidMount:", error);
            localStorage.clear();
            window.location.href = '/';
        }
    }

    private handleAddNewBankPartner = () => {
        this.setState({
            isOpenBankPartnerForm: true,
            isEditMode: false,
            selectedBankPartner: {} as IBankPartner
        });
    };

    public render() {
        const { bankPartner, searchText, totalRows, paginationReset } = this.state;
        return (
            <>
                <div className="body-sub-container table-container">
                    <DataGrid
                        title='Bank Partners'
                        search='bank name'
                        defaultSearch={searchText}
                        onSearch={(searchText_: string) => {
                            this.setState({
                                searchText: searchText_,
                                currentPage: 1
                            }, () => {
                                this.getAllBankPartners();
                            });
                        }}
                        columns={this.tableColumns}
                        data={this.state.bankPartnerList}
                        onChangePage={(page: number, totalRows: number) => {
                            this.setState({
                                currentPage: page
                            }, () => {
                                this.getAllBankPartners();
                            })
                        }}
                        onChangeRowsPerPage={(currentRowsPerPage_: number, currentPage_: number) => {
                            this.setState({
                                currentRowsPerPage: currentRowsPerPage_,
                                currentPage: currentPage_
                            }, () => {
                                this.getAllBankPartners();
                            })
                        }}
                        pagination
                        paginationTotalRows={totalRows}
                        exportCsv={bankPartner.isDownloadVisible ? true : false}
                        csvFileName={'Bank Partners'}
                        isPromoCodeAddVisible={bankPartner.isAddPartner ? true : false}
                        isAddNewBankPartners={this.handleAddNewBankPartner}
                        paginationDefaultPage={1}
                        paginationResetDefaultPage={paginationReset}
                    />
                </div>
                {
                    this.state.isOpenBankPartnerForm && (
                        <BankPartnerForm
                            open={this.state.isOpenBankPartnerForm}
                            onClose={(state: boolean, action: string) => {
                                this.setState({
                                    isOpenBankPartnerForm: false
                                })
                                if (action === 'success') {
                                    this.getAllBankPartners();
                                }
                            }}
                            selectedBankPartner={this.state.isEditMode ? this.state.selectedBankPartner : null}
                            accessToken={this.state.accessToken}
                            isEditMode={this.state.isEditMode}
                        />
                    )
                }
            </>
        )
    }

    // Fetch all bank partners
    private async getAllBankPartners() {
        let pageIndex: number = this.state.currentPage;
        let pagination: any = {
            pageNumber: pageIndex,
            recordPerPage: this.state.currentRowsPerPage
        };

        if (this.state.searchText) {
            pagination["searchText"] = this.state.searchText;
        }

        try {
            const response = await BankPartnerServices.getAllBankPartners(this.state.accessToken, pagination);

            if (response.ok) {
                const resp = await response.json();
                this.setState({
                    bankPartnerList: resp.data || [],
                    totalRows: resp.totalRecords,
                });
            } else {
                ShowAlert("Error", "Failed to fetch bank partners. Please try again later.", "error");
            }
        } catch (error) {
            console.error("Error fetching bank partners:", error);
            ShowAlert("Error", "An unexpected error occurred while fetching bank partners.", "error");
        }
    }

    // Delete a Bank Partner
    private async deleteBankPartner(row_: IBankPartner) {
        try {
            const fintechBankingPartnerId = row_.fintechBankingPartnerId;

            const response = await BankPartnerServices.deleteBankPartner(
                this.state.accessToken,
                fintechBankingPartnerId
            );

            if (response?.ok) {
                await this.getAllBankPartners();
                ShowAlert("Success", "Bank partner has been deleted successfully.", "success");
            } else {
                const errorData = await response.json().catch(() => ({}));
                const errorMessage = errorData.message || "Failed to delete the bank partner. Please try again later.";
                ShowAlert("Error", errorMessage, "error");
            }
        } catch (error) {
            console.error("Error deleting bank partner:", error);
            ShowAlert("Error", "An unexpected error occurred while deleting the bank partner. Please try again.", "error");
        }
    }
}

export default BankPartners;